module.exports = __webpack_public_path__ + "img/tips_bg_red.2dba2b67.png";